export const BILLING_PROVIDER_META_NAME = "billing-provider";
export const BILLING_PROVIDER_CHANGED_EVENT = "constructorfleet:billing-provider-changed";

export function readBillingProviderMeta() {
  return (
    document.querySelector<HTMLMetaElement>(`meta[name="${BILLING_PROVIDER_META_NAME}"]`)
      ?.content ?? "demo"
  );
}

export function setBillingProviderMeta(provider: string) {
  const existingMeta = document.querySelector<HTMLMetaElement>(
    `meta[name="${BILLING_PROVIDER_META_NAME}"]`
  );
  if (existingMeta) {
    existingMeta.content = provider;
    window.dispatchEvent(new CustomEvent(BILLING_PROVIDER_CHANGED_EVENT, { detail: provider }));
    return;
  }

  const meta = document.createElement("meta");
  meta.name = BILLING_PROVIDER_META_NAME;
  meta.content = provider;
  document.head.appendChild(meta);

  window.dispatchEvent(new CustomEvent(BILLING_PROVIDER_CHANGED_EVENT, { detail: provider }));
}
